import { api } from '../services/api';
export const getCRM = ({ path: { subdomain }, ...options }) => api.get(`/communities/${subdomain}/crm`, options);
export const getView = ({ path: { subdomain }, ...options }) => api.get(`/communities/${subdomain}/crm/view`, options);
export const updateView = ({ path: { subdomain }, ...options }) => api.patch(`/communities/${subdomain}/crm/view`, options);
export const crmAction = ({ path: { subdomain }, ...options }) => api.post(`/communities/${subdomain}/crm/action`, options);
